import { ArrowRight } from "lucide-react";
const CaseStudySection = () => {
  return <section className="section-padding bg-gray-50 relative overflow-hidden">
      {/* Decorative background element */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-gray-100 opacity-70"></div>
      
      <div className="container-custom relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-drcash-maastricht-blue mb-6">
            Caso de Sucesso
          </h2>
          <div className="h-1 w-20 bg-gradient-to-r from-drcash-caribbean-green to-drcash-tiffany-blue rounded-full mx-auto mb-6"></div>
          <p className="text-gray-700 max-w-2xl mx-auto">
            Conheça como a Dr.Cash tem ajudado clínicas a melhorar sua saúde financeira e expandir seus negócios.
          </p>
        </div>
        
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden max-w-5xl mx-auto">
          <div className="grid md:grid-cols-2">
            <div className="order-2 md:order-1 p-8 flex flex-col justify-center">
              <h3 className="text-2xl font-bold text-drcash-maastricht-blue mb-4">
                Clínica Orthomed aumentou receita em 45%
              </h3>
              <div className="space-y-4 text-gray-700 mb-6">
                <p>
                  "Desde que implementamos o Boleto Parcelado da Dr.Cash, nosso ticket médio aumentou significativamente e mais pacientes puderam realizar procedimentos de alta complexidade."
                </p>
                <p>
                  "A antecipação de recebíveis também nos permitiu reinvestir na clínica mais rapidamente, aumentando nossa capacidade de atendimento em 30%."
                </p>
              </div>
              <div className="flex items-center">
                <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80" alt="Dr. Ricardo Mendes" className="w-14 h-14 rounded-full mr-4 object-cover" />
                <div>
                  <p className="font-bold text-drcash-sapphire-blue">Dr. Ricardo Mendes</p>
                  <p className="text-sm text-gray-600">Diretor Clínico - Orthomed</p>
                </div>
              </div>
              
            </div>
            <div className="order-1 md:order-2">
              <img alt="Clínica Orthomed" className="w-full h-full object-cover" src="http://drcash.com.br/wp-content/uploads/2025/04/imagem-depo-site.jpg" />
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default CaseStudySection;